module.exports = __webpack_public_path__ + "static/media/p8.549e2af1.jpeg";